import React, { Component } from "react";
import { NavTop } from "../../components";
import "./styles.css";

const HeaderTop = props => {
  return (
    <div className="header-top">
      <div className="content">
        <div className="nav-top-cell">
          <NavTop />
        </div>
      </div>
    </div>
  );
};

export default HeaderTop;



// WEBPACK FOOTER //
// ./src/components/HeaderTop/HeaderTop.js